module.exports = __webpack_public_path__ + "src/assets/img/guestlist_double2.497cd901.jpg";